<footer [class]="theme">
  <div>lotta Binding-App</div>
  <span>Version 1.0.2</span>
</footer>